const e="en-US";export{e as DEFAULT_LOCALE};
//# sourceMappingURL=constants.js.map
